import { Environment, Language, Subsidiary } from '@coolblue-development/constants';
import { getServerRequestContext } from '@coolblue-development/next-request-context/server';
import { stringifyQueryObject } from '@coolblue-development/next-routing-utils';
import { compile } from 'path-to-regexp';
import { getRouting } from '../Routing/RoutingRepository.js';
export const generateUrl = (route, params, options) => {
    var _a, _b;
    const { routes } = getRouting();
    const context = getServerRequestContext();
    if ((options === null || options === void 0 ? void 0 : options.subsidiary) && !options.language) {
        throw new Error('Need to provide a language when providing a subsidiary');
    }
    const language = (options === null || options === void 0 ? void 0 : options.language) || context.language;
    const subsidiary = (options === null || options === void 0 ? void 0 : options.subsidiary) || context.subsidiary;
    const absoluteUrl = !!(options === null || options === void 0 ? void 0 : options.subsidiary) || Boolean(options === null || options === void 0 ? void 0 : options.absoluteUrl);
    const pathInfo = (_b = (_a = routes[route]) === null || _a === void 0 ? void 0 : _a[subsidiary]) === null || _b === void 0 ? void 0 : _b[language];
    if (!pathInfo || !pathInfo.path) {
        return undefined;
    }
    const url = compile(pathInfo.path)(params || {});
    return (getHost(subsidiary, context.environment, absoluteUrl) +
        getPrefix(subsidiary, language) +
        url +
        addQuery(params, pathInfo.pathParams));
};
export const generateUrlForPath = (path, params, options) => {
    const context = getServerRequestContext();
    if ((options === null || options === void 0 ? void 0 : options.subsidiary) && !options.language) {
        throw new Error('Need to provide a language when providing a subsidiary');
    }
    const language = (options === null || options === void 0 ? void 0 : options.language) || context.language;
    const subsidiary = (options === null || options === void 0 ? void 0 : options.subsidiary) || context.subsidiary;
    const absoluteUrl = !!(options === null || options === void 0 ? void 0 : options.subsidiary) || Boolean(options === null || options === void 0 ? void 0 : options.absoluteUrl);
    let url = path.startsWith('/') ? path : `/${path}`;
    url = url.endsWith('/') ? url.slice(0, -1) : url;
    return (getHost(subsidiary, context.environment, absoluteUrl) +
        getPrefix(subsidiary, language) +
        url +
        addQuery(params, []));
};
const addQuery = (params, pathParams) => {
    if (!params || !Object.keys(params).length) {
        return '';
    }
    if (!pathParams.length) {
        return '?' + stringifyQueryObject(params);
    }
    const queryParams = {};
    for (const param of Object.keys(params)) {
        if (pathParams.includes(param)) {
            continue;
        }
        queryParams[param] = params[param];
    }
    if (!Object.keys(queryParams).length) {
        return '';
    }
    return '?' + stringifyQueryObject(queryParams);
};
const getHost = (subsidiary, environment, absoluteUrl) => {
    if (!absoluteUrl) {
        return '';
    }
    switch (environment) {
        case Environment.DEVELOPMENT:
        case Environment.CI:
        case Environment.TESTING:
            return `https://www-coolblue-${subsidiary}.tst.zone`;
        case Environment.ACCEPTANCE:
            return `https://www-coolblue-${subsidiary}.accept.zone`;
        case Environment.PRODUCTION:
        default:
            return `https://www.coolblue.${subsidiary}`;
    }
};
const getPrefix = (subsidiary, language) => {
    switch (subsidiary) {
        case Subsidiary.BE:
            switch (language) {
                case Language.ENGLISH:
                    return '/en';
                case Language.FRENCH:
                    return '/fr';
                case Language.DUTCH:
                    return '/nl';
                default:
                    return '';
            }
        case Subsidiary.DE:
            switch (language) {
                case Language.ENGLISH:
                    return '/en';
                default:
                    return '';
            }
        case Subsidiary.NL:
            switch (language) {
                case Language.ENGLISH:
                    return '/en';
                default:
                    return '';
            }
        default:
            return '';
    }
};
//# sourceMappingURL=generateUrl.js.map